import { removeFromNotificationsByCollabID } from '../../notify/Notification/helper'
import { CollaborationRepository, RoomRepository } from '../repository'

export type HandleQueuedChatParams = {
  collaborationId: string
  roomId: string
  userId: string
}

export type QueuedChatSelection = {
  collaborationIds: string
  roomId: string
}

export const handleQueuedChat = async ({
  collaborationId,
  roomId,
  userId,
}: HandleQueuedChatParams): Promise<boolean> => {
  try {
    removeFromNotificationsByCollabID(collaborationId)
    await CollaborationRepository.setStatusToHandled(collaborationId, userId)
    await RoomRepository.setStatusToHandled(collaborationId, roomId, userId)
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

export const handleQueuedChats = async (
  selectedIds: QueuedChatSelection[],
  userId: string
): Promise<void> => {
  for (const selectedId of selectedIds) {
    await handleQueuedChat({
      collaborationId: selectedId.collaborationIds,
      roomId: selectedId.roomId,
      userId,
    })
  }
}
